import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import useChallengeWireSummary from '../../../hooks/useChallengeWireSummary';
import PageTitle from '../../FormElements/PageTitle';
import LandingPageExitMenu from '../../Navigation/LandingPageExitMenu';
import getLandingImageHeight from '../../../utils/getLandingImageHeight';
import UserBadgesCard from '../../User/UserBadgesCard/UserBadgesCard';
import UserTrophiesCard from '../../User/UserTrophiesCard/UserTrophiesCard';
import UserRostersAlertsCard from '../../User/UserRostersAlertsCard/UserRostersAlertsCard';
import Modal from '../../Modal/Modal';
import ScoutOffice from '../../../../assets/images/scout_office.jpeg';
import MidGmOffice from '../../../../assets/images/mid_gm_office.jpeg';
import BestGmOffice from '../../../../assets/images/best_gm_office2.jpg';

function FrontOfficePage({ get_user_endpoint }) {
	const { user, endpoints, csrfToken } = useAuth();
	const summary = useChallengeWireSummary(user, endpoints, csrfToken);
	const [
		isBadgesModalOpen,
		setIsBadgesModalOpen
	] = useState(false);
	const [
		isTrophiesModalOpen,
		setIsTrophiesModalOpen
	] = useState(false);
	const [
		isRostersAlertsModalOpen,
		setIsRostersAlertsModalOpen
	] = useState(false);
	const [
		isPhoneModalOpen,
		setIsPhoneModalOpen
	] = useState(false);
	const [
		currentIndex,
		setCurrentIndex
	] = useState(0);
	const [
		phoneNumber,
		setPhoneNumber
	] = useState('');
	const images = [
		ScoutOffice,
		MidGmOffice,
		BestGmOffice
	];

	const handleBadgesModalOpen = () => setIsBadgesModalOpen(true);
	const handleBadgesModalClose = () => setIsBadgesModalOpen(false);
	const handleTrophiesModalOpen = () => setIsTrophiesModalOpen(true);
	const handleTrophiesModalClose = () => setIsTrophiesModalOpen(false);
	const handleRostersAlertsModalOpen = () => setIsRostersAlertsModalOpen(true);
	const handleRostersAlertsModalClose = () =>
		setIsRostersAlertsModalOpen(false);
	const handleClickSpotlight = () => {
		window.location.href = '/dashboard';
	};

	const handlePhoneModalOpen = () => {
		setIsPhoneModalOpen(true);
		setPhoneNumber('');
	};

	const handlePhoneModalClose = () => {
		setIsPhoneModalOpen(false);
		setPhoneNumber('');
	};

	const handlePhoneNumberChange = (e) => {
		// Allow only valid phone characters
		const value = e.target.value.replace(/[^\d\+\*\#]/g, '');
		setPhoneNumber(value);
	};

	const handleDialPadClick = (digit) => {
		setPhoneNumber((prev) => prev + digit);
	};

	const handleBackspace = () => {
		setPhoneNumber((prev) => prev.slice(0, -1));
	};

	const handleBackspaceOrClose = () => {
		if (phoneNumber.trim().length > 0) {
			handleBackspace();
			return;
		}
		handlePhoneModalClose();
	};

	const handleClear = () => {
		setPhoneNumber('');
	};

	const handleMakeCall = () => {
		if (phoneNumber.trim()) {
			// Clean the phone number - remove spaces, dashes, parentheses
			const cleanNumber = phoneNumber.replace(/[\s\-\(\)]/g, '');
			// Add +1 if no country code is provided
			const formattedNumber = cleanNumber.startsWith('+')
				? cleanNumber
				: `+1${cleanNumber}`;
			window.location.href = `tel:${formattedNumber}`;
			handlePhoneModalClose();
		}
	};

	const handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			handleMakeCall();
		} else if (e.key === 'Backspace') {
			e.preventDefault();
			handleBackspace();
		} else if (/^[\d\*\#\+]$/.test(e.key)) {
			e.preventDefault();
			handleDialPadClick(e.key);
		}
	};

	const handleOpenContacts = () => {
		// Open device contacts/phone book
		window.location.href = 'tel:';
		handlePhoneModalClose();
	};

	const nextImage = () => {
		setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
	};

	const prevImage = () => {
		setCurrentIndex(
			(prevIndex) => (prevIndex - 1 + images.length) % images.length
		);
	};

	return (
		<div className="container p-4 pt-4 lg:py-16 md:px-20">
			<div>
				<PageTitle title="Work. Rise. Dominate." />
			</div>
			<div className="relative mt-4 rounded-lg overflow-hidden shadow-lg">
				<img
					src={images[2]}
					alt="GM Office"
					decoding="async"
					className="block w-full object-cover object-center"
					style={getLandingImageHeight()}
				/>

				{/* Lock Overlay for Locked Images */}

				{/* {currentIndex === 1 && (
          <div className="absolute inset-0 bg-black bg-opacity-60 flex items-center justify-center rounded-lg z-20">
            <div className="text-center text-white">
              <p className="text-xl font-bold p-6">
                Complete 5 courses to unlock the Assistant GM Office
              </p>
              <a
                href="/courses"
                className="text-blue-500 hover:underline font-semibold"
              >
                Go to courses
              </a>
            </div>
          </div>
        )}
        {currentIndex === 2 && (
          <div className="absolute inset-0 bg-black bg-opacity-60 flex items-center justify-center rounded-lg z-20">
            <div className="text-center text-white">
              <p className="text-xl font-bold p-6">
                Complete 9 courses to unlock the Executive GM Office
              </p>
              <a
                href="/courses"
                className="text-blue-500 hover:underline font-semibold"
              >
                Go to courses
              </a>
            </div>
          </div>
        )} */}

				{/* Icon Bar Inside Image */}
				<div className="absolute bottom-2 md:bottom-4 left-1/2 z-10 -translate-x-1/2 transform">
					<div className="flex items-center justify-center gap-6 p-3 rounded-full">
						<div
							className="w-12 h-12 flex items-center justify-center bg-blue-500 border border-gray-200 text-white text-2xl rounded-full cursor-pointer hover:scale-105 transition-transform transform hover:scale-105 backdrop-blur-md"
							onClick={handleClickSpotlight}
							title="Computer"
						>
							🖥️
						</div>
						<Link
							to="/rosters"
							title="My Rosters"
							className="w-12 h-12 flex items-center justify-center bg-blue-500 border border-gray-200 text-white text-2xl rounded-full cursor-pointer hover:scale-105 transition-transform transform backdrop-blur-md"
						>
							<span aria-hidden>📋</span>
						</Link>
						<div
							className="w-12 h-12 flex items-center justify-center bg-blue-500 border border-gray-200 text-white text-2xl rounded-full cursor-pointer hover:scale-105 transition-transform transform hover:scale-105 backdrop-blur-md"
							onClick={handlePhoneModalOpen}
							title="Make a Phone Call"
						>
							📞
						</div>
						{/*
          <div
            className="w-12 h-12 flex items-center justify-center bg-blue-500 border border-gray-200 text-white text-2xl rounded-full cursor-pointer hover:scale-105 transition-transform transform hover:scale-105 backdrop-blur-md"
            onClick={handleBadgesModalOpen}
          >
            🔰
          </div>
          
					<div
						className="w-12 h-12 flex items-center justify-center bg-blue-500 border border-gray-200 text-white text-2xl rounded-full cursor-pointer hover:scale-105 transition-transform transform hover:scale-105 backdrop-blur-md"
						onClick={() => (window.location.href = '/alerts')}
						title="Alerts Inbox"
					>
						📢
					</div>
					*/}
						<div
							className="w-12 h-12 flex items-center justify-center bg-blue-500 border border-gray-200 text-white text-2xl rounded-full cursor-pointer hover:scale-105 transition-transform transform hover:scale-105 backdrop-blur-md"
							onClick={handleTrophiesModalOpen}
						>
							🏆
						</div>
						<LandingPageExitMenu
							currentPage="front-office"
							summary={summary}
							triggerTitle="Leave Front Office"
							containerClassName="relative w-12 h-12 md:hidden"
							triggerClassName="w-full h-full flex items-center justify-center bg-blue-500 border border-gray-200 text-white text-2xl rounded-full cursor-pointer hover:scale-105 transition-transform transform backdrop-blur-md"
						/>
					</div>
				</div>
				<div className="hidden md:block absolute bottom-4 right-4 z-10">
					<LandingPageExitMenu
						currentPage="front-office"
						summary={summary}
						triggerTitle="Leave Front Office"
					/>
				</div>

				{/* Left and Right Arrow Buttons */}
				{/*<button
          onClick={prevImage}
          className="absolute top-1/2 transform -translate-y-1/2 bg-gray-200 p-3 rounded-md z-30 border border-gray-300"
          style={{ left: '-15px' }}
        >
          {'<'}
        </button>
        <button
          onClick={nextImage}
          className="absolute top-1/2 transform -translate-y-1/2 bg-gray-200 p-3 rounded-md z-30 border border-gray-300"
          style={{ right: '-15px' }}
        >
          {'>'}
        </button> */}
			</div>

			<div>
				{/* Modals */}
				{isBadgesModalOpen && (
					<Modal onClose={handleBadgesModalClose}>
						<UserBadgesCard user={user} />
					</Modal>
				)}
				{isTrophiesModalOpen && (
					<Modal onClose={handleTrophiesModalClose}>
						<UserTrophiesCard
							userId={user.id}
							get_user_endpoint={get_user_endpoint}
						/>
					</Modal>
				)}
				{isRostersAlertsModalOpen && (
					<Modal onClose={handleRostersAlertsModalClose}>
						<UserRostersAlertsCard />
					</Modal>
				)}
				{isPhoneModalOpen && (
					<div
						className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center"
						style={{ zIndex: 100 }}
					>
						<div
							className="bg-black p-6 rounded-2xl max-w-sm md:mt-16 mx-auto border border-gray-800"
							onKeyDown={handleKeyDown}
							tabIndex={0}
							style={{
								boxShadow: '0 20px 60px rgba(0, 0, 0, 0.8)'
							}}
						>
							{/* Black 2010s Flat Header */}
							<div className="text-center mb-6">
								<div className="flex items-center justify-center mb-4 hidden md:flex">
									<div
										className="w-16 h-16 bg-gray-900 rounded-full flex items-center justify-center border border-gray-800"
										style={{
											boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)'
										}}
									>
										<span className="text-3xl">📱</span>
									</div>
								</div>
								<h2
									className="text-2xl font-normal text-white mb-1"
									style={{
										fontFamily:
											'Roboto, "San Francisco", -apple-system, BlinkMacSystemFont, sans-serif',
										fontWeight: 300,
										letterSpacing: '-0.5px'
									}}
								>
									Phone
								</h2>
								<p
									className="text-sm text-gray-500"
									style={{
										fontFamily:
											'Roboto, "San Francisco", -apple-system, BlinkMacSystemFont, sans-serif',
										fontWeight: 400
									}}
								>
									Enter a number to call
								</p>
							</div>

							{/* Display Screen - Black Flat Style */}
							<div className="bg-gray-900 border border-gray-800 rounded-xl p-4 mb-6">
								<div className="flex items-center justify-between min-h-[60px]">
									<input
										type="tel"
										value={phoneNumber}
										onChange={handlePhoneNumberChange}
										placeholder="Enter phone number"
										className="bg-transparent border-none text-white text-3xl font-light w-full focus:outline-none placeholder-gray-600"
										style={{
											fontFamily:
												'Roboto, "San Francisco", -apple-system, BlinkMacSystemFont, sans-serif',
											fontWeight: 300,
											letterSpacing: '0.5px'
										}}
										inputMode="none"
										readOnly
									/>
									{phoneNumber && (
										<button
											onClick={handleClear}
											className="ml-3 text-gray-500 hover:text-gray-300 transition-colors"
											title="Clear"
										>
											<svg
												className="w-6 h-6"
												fill="none"
												stroke="currentColor"
												viewBox="0 0 24 24"
											>
												<path
													strokeLinecap="round"
													strokeLinejoin="round"
													strokeWidth={2}
													d="M6 18L18 6M6 6l12 12"
												/>
											</svg>
										</button>
									)}
								</div>
							</div>

							{/* Dial Pad - Black Flat Material Design Style */}
							<div className="grid grid-cols-3 gap-4 mb-6">
								{[
									{ digit: '1', letters: '' },
									{ digit: '2', letters: 'ABC' },
									{ digit: '3', letters: 'DEF' },
									{ digit: '4', letters: 'GHI' },
									{ digit: '5', letters: 'JKL' },
									{ digit: '6', letters: 'MNO' },
									{ digit: '7', letters: 'PQRS' },
									{ digit: '8', letters: 'TUV' },
									{ digit: '9', letters: 'WXYZ' },
									{ digit: '*', letters: '' },
									{ digit: '0', letters: '+' },
									{ digit: '#', letters: '' }
								].map((item) => (
									<button
										key={item.digit}
										onClick={() => handleDialPadClick(item.digit)}
										className="bg-gray-900 hover:bg-gray-800 active:bg-gray-950 text-white rounded-full h-16 w-16 mx-auto flex flex-col items-center justify-center transition-all border border-gray-800"
										style={{
											boxShadow: '0 2px 8px rgba(0, 0, 0, 0.5)',
											fontFamily:
												'Roboto, "San Francisco", -apple-system, BlinkMacSystemFont, sans-serif'
										}}
									>
										<span className="text-2xl" style={{ fontWeight: 300 }}>
											{item.digit}
										</span>
										{item.letters && (
											<span
												className="text-[8px] text-gray-500 tracking-widest mt-0.5"
												style={{ fontWeight: 400 }}
											>
												{item.letters}
											</span>
										)}
									</button>
								))}
							</div>

							{/* Action Buttons - Black Flat Material Design Style */}
							<div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
								{/* Hide Contacts button on mobile, show on desktop */}
								<button
									onClick={handleOpenContacts}
									className="hidden md:flex bg-gray-900 hover:bg-gray-800 border border-gray-800 text-gray-200 py-4 rounded-lg font-medium text-base transition-colors items-center justify-center"
									style={{
										fontFamily:
											'Roboto, "San Francisco", -apple-system, BlinkMacSystemFont, sans-serif',
										fontWeight: 500
									}}
								>
									<svg
										className="w-5 h-5 mr-2"
										fill="none"
										stroke="currentColor"
										viewBox="0 0 24 24"
									>
										<path
											strokeLinecap="round"
											strokeLinejoin="round"
											strokeWidth={2}
											d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
										/>
									</svg>
									Contacts
								</button>
								{/* Call button - full width on mobile, half width on desktop */}
								<button
									onClick={handleMakeCall}
									disabled={!phoneNumber.trim()}
									className="bg-green-600 hover:bg-green-700 active:bg-green-800 disabled:bg-gray-800 disabled:cursor-not-allowed text-white py-4 rounded-lg font-medium text-base transition-colors flex items-center justify-center"
									style={{
										boxShadow: phoneNumber.trim()
											? '0 2px 8px rgba(34, 197, 94, 0.4)'
											: 'none',
										fontFamily:
											'Roboto, "San Francisco", -apple-system, BlinkMacSystemFont, sans-serif',
										fontWeight: 500
									}}
								>
									<svg
										className="w-5 h-5 mr-2"
										fill="none"
										stroke="currentColor"
										viewBox="0 0 24 24"
									>
										<path
											strokeLinecap="round"
											strokeLinejoin="round"
											strokeWidth={2}
											d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
										/>
									</svg>
									Call
								</button>
							</div>

							{/* Backspace and Cancel - Black Flat Material Design Style */}
							<div className="flex items-center justify-between gap-4 pt-2">
								<button
									onClick={handleBackspaceOrClose}
									className="text-gray-500 hover:text-gray-300 transition-colors p-2"
									title={phoneNumber.trim().length > 0 ? 'Delete' : 'Close'}
								>
									<svg
										className="w-7 h-7"
										fill="none"
										stroke="currentColor"
										viewBox="0 0 24 24"
									>
										<path
											strokeLinecap="round"
											strokeLinejoin="round"
											strokeWidth={2}
											d="M12 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M3 12l6.414 6.414a2 2 0 001.414.586H19a2 2 0 002-2V7a2 2 0 00-2-2h-8.172a2 2 0 00-1.414.586L3 12z"
										/>
									</svg>
								</button>
								<button
									onClick={handlePhoneModalClose}
									className="text-gray-500 hover:text-gray-300 text-sm font-medium transition-colors"
									style={{
										fontFamily:
											'Roboto, "San Francisco", -apple-system, BlinkMacSystemFont, sans-serif',
										fontWeight: 500
									}}
								>
									Cancel
								</button>
							</div>
						</div>
					</div>
				)}
			</div>
		</div>
	);
}

export default FrontOfficePage;
